import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { getPanelCount } from '_helpers';
import { SpecTestsAnkle } from './SpecTestsAnkle';
import { SpecTestsBalanceTesting } from './SpecTestsBalanceTesting';
import { SpecTestsBehavior } from './SpecTestsBehavior';
import { SpecTestsCervical } from './SpecTestsCervical';
import { SpecTestsCervicalMyelopathyCPR } from './SpecTestsCervicalMyelopathyCPR';
import { SpecTestsCervicalRadiculopathyClusterTest } from './SpecTestsCervicalRadiculopathyClusterTest';
import { SpecTestsClosedCervicalFractureCPR } from './SpecTestsClosedCervicalFractureCPR';
import { SpecTestsCognition } from './SpecTestsCognition';
import { SpecTestsComments } from './SpecTestsComments';
import { SpecTestsConcussion } from './SpecTestsConcussion';
import { SpecTestsCoordination } from './SpecTestsCoordination';
import { SpecTestsCranialNerveTesting } from './SpecTestsCranialNerveTesting';
import { SpecTestsCTSIB } from './SpecTestsCTSIB';
import { SpecTestsDTR } from './SpecTestsDTR';
import { SpecTestsElbow } from './SpecTestsElbow';
import { SpecTestsFullThicknessRotatorCuffTearCluster } from './SpecTestsFullThicknessRotatorCuffTearCluster';
import { SpecTestsHand } from './SpecTestsHand';
import { SpecTestsHearingLoss } from './SpecTestsHearingLoss';
import { SpecTestsHip } from './SpecTestsHip';
import { SpecTestsGazeStabilization } from './SpecTestsGazeStabilization';
import { SpecTestsExaminationTesting } from './SpecTestsExaminationTesting';
import { SpecTestsImpingementClusterTest } from './SpecTestsImpingementClusterTest';
import { SpecTestsKnee } from './SpecTestsKnee';
import { SpecTestsLabralTear } from './SpecTestsLabralTear';
import { SpecTestsLumbar } from './SpecTestsLumbar';
import { SpecTestsLumbarInstabilityCPR } from './SpecTestsLumbarInstabilityCPR';
import { SpecTestsLumbarManipulationCPR } from './SpecTestsLumbarManipulationCPR';
import { SpecTestsLumbarManipulationTestCluster } from './SpecTestsLumbarManipulationTestCluster';
import { SpecTestsMuscleTone } from './SpecTestsMuscleTone';
import { SpecTestsNerveTests } from './SpecTestsNerveTests';
import { SpecTestsNeurodynamicAssessment } from './SpecTestsNeurodynamicAssessment';
import { SpecTestsPelvicBowelMovements } from './SpecTestsPelvicBowelMovements';
import { SpecTestsPelvicFloorAssessment } from './SpecTestsPelvicFloorAssessment';
import { SpecTestsPelvicBreathingAssessment } from './SpecTestsPelvicBreathingAssessment';
import { SpecTestsPelvicGirdle } from './SpecTestsPelvicGirdle';
import { SpecTestsPrimativeReflexes } from './SpecTestsPrimativeReflexes';
import { SpecTestsProtectiveReactions } from './SpecTestsProtectiveReactions';
import { SpecTestsReflexes } from './SpecTestsReflexes';
import { SpecTestsRightingReactionsStrategy } from './SpecTestsRightingReactionsStrategy';
import { SpecTestsRotatorCuffTearCluster } from './SpecTestsRotatorCuffTearCluster';
import { SpecTestsSensation } from './SpecTestsSensation';
import { SpecTestsShoulder } from './SpecTestsShoulder';
import { SpecTestsSIJCluster } from './SpecTestsSIJCluster';
import { SpecTestsSIJTests } from './SpecTestsSIJTests';
import { SpecTestsSpinalStenosisCPR } from './SpecTestsSpinalStenosisCPR';
import { SpecTestsSynergies } from './SpecTestsSynergies';
import { SpecTestsThoracicOutlet } from './SpecTestsThoracicOutlet';
import { SpecTestsVestibular } from './SpecTestsVestibular';
import { SpecTestsUMNTest } from './SpecTestsUMNTest';
import { SpecTestsVisualocularMotorFunction } from './SpecTestsVisualocularMotorFunction';
import { SpecTestsWrist } from './SpecTestWrist';
import { SpecTestsObjectManipulation } from './SpecTestsObjectManipulation';

class PatientCareCenterNoteObjectiveSpecTests extends React.Component {

    render() {
        if (this.props.panelCount > 0) {
            return (
                <PatientCareCenterNoteSection id='obj_spec_tests' name='Special Tests' level={1} noChildPadding={true}>
                    <SpecTestsAnkle />
                    <SpecTestsBalanceTesting />
                    <SpecTestsBehavior />
                    <SpecTestsCervical />
                    <SpecTestsCervicalMyelopathyCPR />
                    <SpecTestsCervicalRadiculopathyClusterTest />
                    <SpecTestsClosedCervicalFractureCPR />
                    <SpecTestsCognition />
                    <SpecTestsComments />
                    <SpecTestsConcussion />
                    <SpecTestsCoordination />
                    <SpecTestsCranialNerveTesting />
                    <SpecTestsCTSIB />
                    <SpecTestsDTR />
                    <SpecTestsElbow />
                    <SpecTestsFullThicknessRotatorCuffTearCluster />
                    <SpecTestsHand />
                    <SpecTestsHearingLoss />
                    <SpecTestsHip />
                    <SpecTestsGazeStabilization />
                    <SpecTestsExaminationTesting />
                    <SpecTestsImpingementClusterTest />
                    <SpecTestsKnee />
                    <SpecTestsLabralTear />
                    <SpecTestsLumbar />
                    <SpecTestsLumbarInstabilityCPR />
                    <SpecTestsLumbarManipulationCPR />
                    <SpecTestsLumbarManipulationTestCluster />
                    <SpecTestsMuscleTone />
                    <SpecTestsNerveTests />
                    <SpecTestsNeurodynamicAssessment />
                    <SpecTestsObjectManipulation />
                    <SpecTestsPelvicBowelMovements />
                    <SpecTestsPelvicBreathingAssessment />
                    <SpecTestsPelvicFloorAssessment />
                    <SpecTestsPelvicGirdle />
                    <SpecTestsPrimativeReflexes />
                    <SpecTestsProtectiveReactions />
                    <SpecTestsReflexes />
                    <SpecTestsRightingReactionsStrategy />
                    <SpecTestsRotatorCuffTearCluster />
                    <SpecTestsSensation />
                    <SpecTestsShoulder />
                    <SpecTestsSIJCluster />
                    <SpecTestsSIJTests />
                    <SpecTestsSpinalStenosisCPR />
                    <SpecTestsSynergies />
                    <SpecTestsThoracicOutlet />
                    <SpecTestsVestibular />
                    <SpecTestsUMNTest />
                    <SpecTestsVisualocularMotorFunction />
                    <SpecTestsWrist />
                </PatientCareCenterNoteSection>
            );
        } else {
            return (
                <span />
            )
        }
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;

    return {
        noteId: noteId,
        panelCount: getPanelCount(noteId, 'SpecialTest')
    };
}

const connectedPatientCareCenterNoteObjectiveSpecTests = connect(mapStateToProps)(PatientCareCenterNoteObjectiveSpecTests);
export { connectedPatientCareCenterNoteObjectiveSpecTests as PatientCareCenterNoteObjectiveSpecTests };

